/**
 * Generated from ch8_p06.fla
 */
export function ch8_p06(this: Ich8_p06) {
	const holly = this.holly;
	if (!holly[0] && holly.elementFactory) {
		holly[0] = holly.elementFactory(0,undefined);
	}
	if (holly[0]) {
		ch8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_hollycatch.call(holly[0] as Ich8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_hollycatch);
		holly[0].x = 418.25;
		holly[0].y = 768;
		holly[0].width = 551.50;
		holly[0].height = 400.00;
		holly[0].alpha = 1;
		if (holly[0].onLayout) holly[0].onLayout();
	}
	if (!holly[1] && holly.elementFactory) {
		holly[1] = holly.elementFactory(1,undefined);
	}
	if (holly[1]) {
		ch8_p06_hh_ch8_72dpi_p06flattenedpsdAsset1chp8_p06_hollyarmscopy.call(holly[1] as Ich8_p06_hh_ch8_72dpi_p06flattenedpsdAsset1chp8_p06_hollyarmscopy);
		holly[1].x = 423.75;
		holly[1].y = 768;
		holly[1].width = 542.50;
		holly[1].height = 396.50;
		holly[1].alpha = 1;
		if (holly[1].onLayout) holly[1].onLayout();
	}
	const lambInAir = this.lambInAir;
	if (!lambInAir[0] && lambInAir.elementFactory) {
		lambInAir[0] = lambInAir.elementFactory(0,undefined);
	}
	if (lambInAir[0]) {
		ch8_p06_chp8_p06_lamb1.call(lambInAir[0] as Ich8_p06_chp8_p06_lamb1);
		lambInAir[0].x = 541;
		lambInAir[0].y = 393.5;
		lambInAir[0].width = 136.00;
		lambInAir[0].height = 110.50;
		lambInAir[0].alpha = 1;
		if (lambInAir[0].onLayout) lambInAir[0].onLayout();
	}
	if (!lambInAir[1] && lambInAir.elementFactory) {
		lambInAir[1] = lambInAir.elementFactory(1,undefined);
	}
	if (lambInAir[1]) {
		ch8_p06_chp8_p06_lamb2.call(lambInAir[1] as Ich8_p06_chp8_p06_lamb2);
		lambInAir[1].x = 541;
		lambInAir[1].y = 393.5;
		lambInAir[1].width = 152.00;
		lambInAir[1].height = 108.50;
		lambInAir[1].alpha = 1;
		if (lambInAir[1].onLayout) lambInAir[1].onLayout();
	}
	const bg = this.bg;
	ch8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_background.call(this.bg);
	bg.x = 832;
	bg.y = 382.5;
	bg.width = 1664.00;
	bg.height = 765.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const water = this.water;
	ch8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_treetopforeground.call(this.water);
	water.x = 832;
	water.y = 643.25;
	water.width = 1664.00;
	water.height = 249.50;
	water.alpha = 1.00;
	if (water.onLayout) water.onLayout();
	const tree = this.tree;
	ch8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_tree.call(this.tree);
	tree.x = 822;
	tree.y = 303.25;
	tree.width = 564.00;
	tree.height = 571.50;
	tree.alpha = 1.00;
	if (tree.onLayout) tree.onLayout();
	const treeTop = this.treeTop;
	ch8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_treetop.call(this.treeTop);
	treeTop.x = 727;
	treeTop.y = 47;
	treeTop.width = 778.00;
	treeTop.height = 94.00;
	treeTop.alpha = 1.00;
	if (treeTop.onLayout) treeTop.onLayout();
	const waterFront = this.waterFront;
	ch8_p06_hh_ch8_72dpi_p06flattenedpsdAssetWaterFront.call(this.waterFront);
	waterFront.x = 403.25;
	waterFront.y = 724.75;
	waterFront.width = 806.50;
	waterFront.height = 85.50;
	waterFront.alpha = 1.00;
	if (waterFront.onLayout) waterFront.onLayout();
	const emptyTire = this.emptyTire;
	ch8_p06_hh_ch8_72dpi_p06lambintirepsdAsset1chp8_p06_emptytire.call(this.emptyTire);
	emptyTire.x = 793.5;
	emptyTire.y = -191.9;
	emptyTire.width = 68.00;
	emptyTire.height = 658.00;
	emptyTire.alpha = 1.00;
	if (emptyTire.onLayout) emptyTire.onLayout();
	const lambInTire = this.lambInTire;
	ch8_p06_hh_ch8_72dpi_p06lambintirepsdAsset1chp8_p06_lambintire.call(this.lambInTire);
	lambInTire.x = 788.75;
	lambInTire.y = 354.6;
	lambInTire.width = 136.50;
	lambInTire.height = 127.00;
	lambInTire.alpha = 1.00;
	if (lambInTire.onLayout) lambInTire.onLayout();
	return this;
}
function ch8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_background(this: Ich8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_background) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p06_background", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_treetopforeground(this: Ich8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_treetopforeground) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p06_treetopforeground", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_tree(this: Ich8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_tree) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p06_tree", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_treetop(this: Ich8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_treetop) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p06_treetop", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p06_hh_ch8_72dpi_p06flattenedpsdAsset1chp8_p06_hollyarmscopy(this: Ich8_p06_hh_ch8_72dpi_p06flattenedpsdAsset1chp8_p06_hollyarmscopy) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p06_hollyarmscopy", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p06_chp8_p06_lamb1(this: Ich8_p06_chp8_p06_lamb1) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p06_lamb1.png", 0.537, 0.498);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p06_chp8_p06_lamb2(this: Ich8_p06_chp8_p06_lamb2) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p06_lamb2.png", 0.480, 0.507);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_hollycatch(this: Ich8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_hollycatch) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p06_hollycatch", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p06_hh_ch8_72dpi_p06flattenedpsdAssetWaterFront(this: Ich8_p06_hh_ch8_72dpi_p06flattenedpsdAssetWaterFront) {
	if (this.setLayoutTexture) this.setLayoutTexture("WaterFront", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p06_hh_ch8_72dpi_p06lambintirepsdAsset1chp8_p06_emptytire(this: Ich8_p06_hh_ch8_72dpi_p06lambintirepsdAsset1chp8_p06_emptytire) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p06_emptytire", 0.500, 0.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p06_hh_ch8_72dpi_p06lambintirepsdAsset1chp8_p06_lambintire(this: Ich8_p06_hh_ch8_72dpi_p06lambintirepsdAsset1chp8_p06_lambintire) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p06_lambintire", 0.500, 0.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich8_p06Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich8_p06Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich8_p06Sprite extends Ich8_p06Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich8_p06Text extends Ich8_p06Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich8_p06Polygon extends Array<number> {
}
interface Ich8_p06 {
	readonly holly: Ich8_p06Array<Ich8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_hollycatch|Ich8_p06_hh_ch8_72dpi_p06flattenedpsdAsset1chp8_p06_hollyarmscopy>;
	readonly lambInAir: Ich8_p06Array<Ich8_p06_chp8_p06_lamb1|Ich8_p06_chp8_p06_lamb2>;
	readonly bg: Ich8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_background;
	readonly water: Ich8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_treetopforeground;
	readonly tree: Ich8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_tree;
	readonly treeTop: Ich8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_treetop;
	readonly waterFront: Ich8_p06_hh_ch8_72dpi_p06flattenedpsdAssetWaterFront;
	readonly emptyTire: Ich8_p06_hh_ch8_72dpi_p06lambintirepsdAsset1chp8_p06_emptytire;
	readonly lambInTire: Ich8_p06_hh_ch8_72dpi_p06lambintirepsdAsset1chp8_p06_lambintire;
}
interface Ich8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_background extends Ich8_p06Sprite {
}
interface Ich8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_treetopforeground extends Ich8_p06Sprite {
}
interface Ich8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_tree extends Ich8_p06Sprite {
}
interface Ich8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_treetop extends Ich8_p06Sprite {
}
interface Ich8_p06_hh_ch8_72dpi_p06flattenedpsdAsset1chp8_p06_hollyarmscopy extends Ich8_p06Sprite {
}
interface Ich8_p06_chp8_p06_lamb1 extends Ich8_p06Sprite {
}
interface Ich8_p06_chp8_p06_lamb2 extends Ich8_p06Sprite {
}
interface Ich8_p06_hh_ch8_72dpi_p06flattenedpsdAssetchp8_p06_hollycatch extends Ich8_p06Sprite {
}
interface Ich8_p06_hh_ch8_72dpi_p06flattenedpsdAssetWaterFront extends Ich8_p06Sprite {
}
interface Ich8_p06_hh_ch8_72dpi_p06lambintirepsdAsset1chp8_p06_emptytire extends Ich8_p06Sprite {
}
interface Ich8_p06_hh_ch8_72dpi_p06lambintirepsdAsset1chp8_p06_lambintire extends Ich8_p06Sprite {
}
